<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="form" inline>
					<c-form-item type="datetime" date-type="date" label="统计时间" start-name="start_date" end-name="end_date"></c-form-item>
				</c-form>
			</m-search>

			<m-operate>
				<c-button power="b_statistic_flow_export" @click="exportData()">导出</c-button>
			</m-operate>
			
			<c-table ref="table">				

				<c-table-column
					label="日期"
					name="statistic_date"
				>
				</c-table-column>
				
				<c-table-column
					label="浏览总人数"
					name="total_uv"
				>
				</c-table-column>
				
				<c-table-column
					label="浏览总量"
					name="total_pv"
				>
				</c-table-column>

				<c-table-column
					label="商品浏览人数"
					name="product_uv"
				>
				</c-table-column>

				<c-table-column
					label="商品浏览量"
					name="product_pv"
				>
				</c-table-column>
				
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/statistic/flow/list',
					data
				});
			},
			exportData(){
				var exportData = this.$refs.form.serialize();
				exportData.job_id = 30;
				exportData.create_system = 'OMS';
				
				this.request({
					url: '/export_job/add',
					data: exportData,
					success: data => {
						this.$message({
		                  	text: '导出任务创建成功，请前往任务中心查看导出进度',
		                  	icon: 'success'
		                });
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>